import {
  Component,
  Input,
  OnInit,
  Inject,
  OnChanges,
  SimpleChanges,
  Output,
} from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { AssignMeterService } from '../../service/assignmeter.service';
import { CommonService } from '../../service/common.service';
import { GSMConfigComponent } from 'src/app/popup/gsmconfig/gsmconfig';
import { DatePipe, formatDate } from '@angular/common';
import { RegisterpanelComponent } from 'src/app/popup/registerpanel/registerpanel';
import { AnalogRegisterpanelComponent } from 'src/app/popup/analogregisterpanel/analogregisterpanel';
import { MatDialog } from '@angular/material/dialog';
import { CompanyService } from 'src/app/service/company.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AnalogDigitalComponent } from './analog-digital-popup/analog-digital-popup.component';
import { VirtualRegisterpanelComponent } from 'src/app/popup/virtualregisterpanel/virtualregisterpanel';
export interface OptionItem {
  id: number;
  name: string;
  show: boolean;
}

@Component({
  selector: 'app-adminaddsite',
  templateUrl: './adminaddsite.component.html',
})
export class AdminaddsiteComponent implements OnInit {
  @Input() CompanyId;
  //Property Declaration
  DPName: string = '';
  Registerdata: [];
  meterConfiguration: [];
  // DeviceTypeList: [];
  AddSiteForm: FormGroup;
  errorMsg: string = '';
  SuccessMsg: string = '';
  RoleName: string = '';
  DisplayButton: boolean = true;
  SiteMasterList: [];
  GSMConfigId: [];
  minDate = new Date();
  lblparameter: string = '';
  windowheight: any;
  divHeight: number;
  tableHeight: number;
  ErrorMassage: string = '';
  message: string = '';
  testIdFromFocus: string = '';
  initialSN: string[] = []; // Mayank Dulera
  initialPN: string[] = []; // Mayank Dulera
  initialEM: string[] = [];
  initialDN: string[] = [];
  EnergyMeterID: number;
  EnergyMeterGSMConfigID: number;
  DeviceTypeId: number;
  DeviceGSMConfigID: any;
  DeviceRTCConfigID: any;
  DeviceMQTConfigID: any;
  AllowedMachines: number;
  EMtoalLength: number = 0;
  IsreadOnly: boolean = false;
  IsreadOnlyForOEM: boolean = false;
  custonDropdown = new FormControl();
  filterControl = new FormControl();
  filteredOptions: Observable<Array<OptionItem>>;
  CompDetail: any[] = [];
  selectedID = 0;
  addtiondevicetype: number;
  DigitalCount: any = 0;
  AnalogCount: any = 0;
  devicecounterlist: any = [];
  newmaindevicedata: any;
  maindict: { [siteindex: number]: { maxanalog: number }[] } = {};

  //Called when window resize
  onResize() {
    this.ResizeHeight();
  }

  //Called function on initial and window resize
  ResizeHeight() {
    this.windowheight = localStorage.getItem('WindowHeight');
    this.divHeight = this.windowheight - 225;
    this.tableHeight = this.divHeight - 45;
  }

  constructor(
    private assignmeterservice: AssignMeterService,
    private commonservice: CommonService,
    private datePipe: DatePipe,
    private form: FormBuilder,
    private dialog: MatDialog, //, //public dialogRef: MatDialogRef<SetParameterComponent>
    private companyservice: CompanyService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.testIdFromFocus = '';
    this.ResizeHeight();
    this.RoleName = localStorage.getItem('RoleName');
    this.AddSiteForm = this.form.group({
      AddSiteArray: this.form.array([]),
    });

    this.initialEM = [];
    this.initialSN = []; // Mayank Dulera
    this.initialPN = []; // Mayank Dulera

    this.custonDropdown.setValue('0');
    this.getCompanyDetails();

    this.filteredOptions = this.filterControl.valueChanges.pipe(
      startWith(''),
      map((value: string) => {
        this.CompDetail.forEach((option) => {
          option.show = option.CompSiteName.toLocaleLowerCase().includes(
            value.toLowerCase()
          );
        });
        return this.CompDetail;
      })
    );

    if (this.RoleName == 'Admin') {
      this.IsreadOnlyForOEM = false;
      this.IsreadOnly = true;
    } else {
      this.IsreadOnlyForOEM = false;
      this.IsreadOnly = false;
    }
  }

  getCompanyDetails() {
    this.companyservice
      .GetCompanyDetails(this.CompanyId, this.selectedID)
      .subscribe(
        (result) => {
          if (result) {
            this.SiteMasterList = result.ListCompSiteMasterBO;
            if (this.SiteMasterList) {
              this.SetSiteDetails();
            }
            this.getInitialEM();
            // this.GetDeviceTypeList();
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
  }

  changeSiteName(id: any) {
    this.selectedID = id;
  }

  onPanelClose() {
    this.filterControl.setValue('');
  }

  searchUser() {
    this.SiteMasterList = [];
    const ArrRow = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    while (ArrRow.length !== 0) {
      ArrRow.removeAt(0);
    }
    this.getCompanyDetails();
  }
  // Set Site Details
  SetSiteDetails() {
    this.SiteMasterList.forEach((element, i) => {
      this.AddSiteRow(this.SiteMasterList[i], i);
    });
  }

  // Add List Row
  AddSiteRow(Row, index) {
    if (!this.CompDetail.some((item) => item.CompSiteId == Row.CompSiteId)) {
      this.CompDetail.push({
        CompSiteId: Row && Row.CompSiteId ? Row.CompSiteId : 0,
        CompSiteName: Row && Row.CompSiteName ? Row.CompSiteName : '',
        show: true,
      });
    }

    const ArrSite = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    ArrSite.push(
      this.form.group({
        CompSiteId: Row && Row.CompSiteId ? Row.CompSiteId : 0,
        CompSiteName: Row && Row.CompSiteName ? Row.CompSiteName : '',
        // Mayank Dulera
        Mode:
          Row && Row.Mode ? Row.Mode : Row && Row.CompSiteId ? 'Edit' : 'Add',
        ListPanelMasterBO: this.form.array([]),
      })
    );
    const ArrPanel = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
      .at(index)
      .get('ListPanelMasterBO') as FormArray;
    Row.ListPanelMasterBO.forEach((element, i) => {
      ArrPanel.push(this.PanelArray(element));
      if (
        Row.ListPanelMasterBO[i].ListDevicetypeMasterBO &&
        Row.ListPanelMasterBO[i].ListDevicetypeMasterBO.length > 0
      ) {
        const ArrDevice = (
          (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
            .at(index)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(i)
          .get('ListDevicetypeMasterBO') as FormArray;

        Row.ListPanelMasterBO[i].ListDevicetypeMasterBO.forEach(
          (element, j) => {
            ArrDevice.push(this.DeviceArray(element));
            if (
              Row.ListPanelMasterBO[i].ListDevicetypeMasterBO[j]
                .ListEnergymeterMasterBO &&
              Row.ListPanelMasterBO[i].ListDevicetypeMasterBO[j]
                .ListEnergymeterMasterBO.length > 0
            ) {
              const ArrEnergy = (
                (
                  (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
                    .at(index)
                    .get('ListPanelMasterBO') as FormArray
                )
                  .at(i)
                  .get('ListDevicetypeMasterBO') as FormArray
              )
                .at(j)
                .get('ListEnergymeterMasterBO') as FormArray;
              Row.ListPanelMasterBO[i].ListDevicetypeMasterBO[
                j
              ].ListEnergymeterMasterBO.forEach((element, k) => {
                ArrEnergy.push(this.EnergyMeterArray(element));
              });
            }
          }
        );
      }
    });
  }

  // Add Panel Array
  PanelArray(lstPanel) {
    return this.form.group({
      Mode:
        lstPanel && lstPanel.Mode
          ? lstPanel.Mode
          : lstPanel && lstPanel.SitePanelId
          ? 'Edit'
          : 'Add',
      SitePanelId: lstPanel.SitePanelId,
      PanelName: lstPanel.PanelName,
      ListDevicetypeMasterBO: this.form.array([]),
    });
  }
  //Add device type Array
  DeviceArray(lstDevice) {
    return this.form.group({
      Mode:
        lstDevice && lstDevice.Mode
          ? lstDevice.Mode
          : lstDevice && lstDevice.DeviceTypeID
          ? 'Edit'
          : 'Add',
      DeviceTypeID: lstDevice.DeviceTypeID > 0 ? lstDevice.DeviceTypeID : 0,
      DeviceName: lstDevice.DeviceName,
      InstallationDate: lstDevice.InstallationDate
        ? [formatDate(lstDevice.InstallationDate, 'yyyy-MM-dd', 'en')][0]
        : '',
      GSMDeviceConfigID: lstDevice.GSMDeviceConfigID,
      GSMConfigDataBO: lstDevice.GSMConfigDataBO,
      RTCSettingDataBO: lstDevice.RTCSettingDataBO,
      MQTTSettingDataBO: lstDevice.MQTTSettingDataBO,
      EthernetTcpSettingsBO: lstDevice.EthernetTcpSettingsBO,
      DeviceProtocol: lstDevice.DeviceProtocol,
      KeyID: lstDevice.KeyID,
      MaximumSlave: lstDevice.MaximumSlave,
      MaxAnalogDevice: lstDevice.MaxAnalogDevice,
      ListEnergymeterMasterBO: this.form.array([]),
    });
  }

  // Add Energy Meter Array
  EnergyMeterArray(lstenergy) {
    return this.form.group({
      Mode:
        lstenergy && lstenergy.Mode
          ? lstenergy.Mode
          : lstenergy && lstenergy.EnergymeterMasterID
          ? 'Edit'
          : 'Add',
      EnergymeterMasterID: lstenergy.EnergymeterMasterID,
      EnergymeterID: lstenergy.EnergymeterID ? lstenergy.EnergymeterID : '',
      EnergymeterDesc: lstenergy.EnergymeterDesc,
      MeterType: lstenergy.MeterType,
      // MeterType: lstenergy.MeterType.toString() == 1 ? 'Digital' : 'Analog',
      IsDisplay: lstenergy.IsDisplay ? lstenergy.IsDisplay : false,
      ValidToDate: lstenergy.ValidTo
        ? [formatDate(lstenergy.ValidTo, 'yyyy-MM-dd', 'en')][0]
        : lstenergy.ValidToDate
        ? [formatDate(lstenergy.ValidToDate, 'yyyy-MM-dd', 'en')][0]
        : '',
      DeviceTypeId: lstenergy.DeviceTypeId > 0 ? lstenergy.DeviceTypeId : 0,
      DeviceType: lstenergy.DeviceType,
      RegisterData: lstenergy.RegisterData,
      meterConfiguration: lstenergy.meterConfiguration,
      MeterName: lstenergy.MeterName,
    });
  }
  //Add Site
  AddSiteArray() {
    return this.form.group({
      // Mayank Dulera
      CompSiteId: [0],
      CompSiteName: [''],
      EnergymeterMasterID: [0],
      SitePanelId: [0],
      Mode: ['Add'],
      ListPanelMasterBO: this.form.array([]),
    });
  }

  //Add Panel
  AddPanelArray() {
    return this.form.group({
      Mode: ['Add'], //Mayank
      PanelName: [''],
      SitePanelId: [0],
      ListDevicetypeMasterBO: this.form.array([]),
    });
  }
  //Add Device type // tathya
  AddDevicetypeArray() {
    return this.form.group({
      Mode: ['Add'],
      DeviceName: [''],
      InstallationDate: [''],
      DeviceId: [0],
      GSMConfigDataBO: [],
      RTCSettingDataBO: [],
      MQTTSettingDataBO: [],
      EthernetTcpSettingsBO: [],
      DeviceProtocol: [''],
      KeyID: [''],
      MaximumSlave: [0],
      MaxAnalogDevice: [0],
      ListEnergymeterMasterBO: this.form.array([]),
    });
  }
  //Add Energy Meter
  AddEnergyMeterArray() {
    return this.form.group({
      EnergymeterID: [''],
      EnergymeterMasterID: [0],
      Mode: ['Add'], //Mayank
      EnergymeterDesc: [''],
      IsDisplay: [false],
      ValidToDate: [''],
      DeviceTypeId: [''],
      DeviceType: [''],
      RegisterData: [],
      meterConfiguration: [],
      MeterName: [''],
      MeterType: [''],
    });
  }

  // Called on click Add Site
  AddSite() {
    const control = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    control.push(this.AddSiteArray());
  }

  // Called on click Add panel
  AddPanel(index) {
    const control = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
      .at(index)
      .get('ListPanelMasterBO') as FormArray;
    control.push(this.AddPanelArray());
  }
  // called on click add device type
  AddDevice(siteIndex, panelIndex) {
    const control = (
      (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
        .at(siteIndex)
        .get('ListPanelMasterBO') as FormArray
    )
      .at(panelIndex)
      .get('ListDevicetypeMasterBO') as FormArray;
    control.push(this.AddDevicetypeArray());
  }

  // Called on click Add Energy Meter
  AddEnergyMeter(siteIndex, panelIndex, deviceIndex) {
    const Setanalogdigital = this.dialog.open(AnalogDigitalComponent, {
      width: '30%',
      height: '170px',
      data: {
        GSMConfigAllData: {
          DeviceTypeID: this.DeviceTypeId,
        },
      },
    });
    const control = (
      (
        (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
          .at(siteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(panelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    )
      .at(deviceIndex)
      .get('ListEnergymeterMasterBO') as FormArray;
    Setanalogdigital.afterClosed().subscribe((result) => {
      this.addtiondevicetype =
        result.metertype == 'Analog'
          ? 2
          : result.metertype == 'Digital'
          ? 1
          : 3;
      if (this.addtiondevicetype == 3) {
        control.push(
          this.form.group({
            EnergymeterID: [''],
            EnergymeterMasterID: [0],
            Mode: ['Add'], //Mayank
            EnergymeterDesc: [''],
            IsDisplay: [false],
            ValidToDate: [''],
            DeviceTypeId: [''],
            DeviceType: [''],
            RegisterData: [],
            meterConfiguration: [],
            MeterName: [''],
            MeterType: [3],
          })
        );
      } else {
        var DeviceControl = (
          (
            (this.AddSiteForm.get('AddSiteArray') as FormArray)
              .at(siteIndex)
              .get('ListPanelMasterBO') as FormArray
          )
            .at(panelIndex)
            .get('ListDevicetypeMasterBO') as FormArray
        ).at(deviceIndex);
        const EnergyMeterLength = (
          (
            (
              (this.AddSiteForm.get('AddSiteArray') as FormArray)
                .at(siteIndex)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(panelIndex)
              .get('ListDevicetypeMasterBO') as FormArray
          )
            .at(deviceIndex)
            .get('ListEnergymeterMasterBO') as FormArray
        ).length;
        const EnergyMeter = (
          (
            (this.AddSiteForm.get('AddSiteArray') as FormArray)
              .at(siteIndex)
              .get('ListPanelMasterBO') as FormArray
          )
            .at(panelIndex)
            .get('ListDevicetypeMasterBO') as FormArray
        )
          .at(deviceIndex)
          .get('ListEnergymeterMasterBO') as FormArray;

        let filterdatadigitalinit = EnergyMeter.value.filter(
          (item: any) => item.MeterType == 1
        ).length;

        let filterdataanaloginit = EnergyMeter.value.filter(
          (item: any) => item.MeterType == 2
        ).length;

        if (this.EMtoalLength + 1 > this.AllowedMachines) {
          this.errorMsg = 'Total Meter count should be same as No of Machines.';
          return;
        }

        for (const item of DeviceControl.value.ListEnergymeterMasterBO) {
          if (item.MeterType == 'Digital' || item.MeterType == 1) {
            this.DigitalCount = this.DigitalCount + 1;
          } else if (item.MeterType == 'Analog' || item.MeterType == 2) {
            this.AnalogCount = this.AnalogCount + 1;
          }
        }
        let filterdatadigital =
          DeviceControl.value.ListEnergymeterMasterBO.filter(
            (item: any) => item.MeterType == 1
          ).length;
        let filterdataanalog =
          DeviceControl.value.ListEnergymeterMasterBO.filter(
            (item: any) => item.MeterType == 2
          ).length;

        if (
          DeviceControl.get('GSMConfigDataBO').value != null &&
          DeviceControl.get('MQTTSettingDataBO').value != null
        ) {
          if (
            +DeviceControl.get('GSMConfigDataBO').value.MaximumSlave > 0 &&
            DeviceControl.get('MQTTSettingDataBO').value.DeviceProtocol != ''
          ) {
            if (this.addtiondevicetype == 1) {
              if (
                filterdatadigitalinit <
                DeviceControl.get('GSMConfigDataBO').value.MaximumSlave
              ) {
                control.push(
                  this.form.group({
                    EnergymeterID: [''],
                    EnergymeterMasterID: [0],
                    Mode: ['Add'], //Mayank
                    EnergymeterDesc: [''],
                    IsDisplay: [false],
                    ValidToDate: [''],
                    DeviceTypeId: [''],
                    DeviceType: [''],
                    RegisterData: [],
                    meterConfiguration: [],
                    MeterName: [''],
                    MeterType: [1],
                  })
                );
              } else {
                this.errorMsg =
                  'No. of Meter should be same as Maximum Slave !!';
              }
            } else if (this.addtiondevicetype == 2) {
              if (
                filterdataanaloginit <
                DeviceControl.get('GSMConfigDataBO').value.MaxAnalogDevice
              ) {
                control.push(
                  this.form.group({
                    EnergymeterID: [''],
                    EnergymeterMasterID: [0],
                    Mode: ['Add'], //Mayank
                    EnergymeterDesc: [''],
                    IsDisplay: [false],
                    ValidToDate: [''],
                    DeviceTypeId: [''],
                    DeviceType: [''],
                    RegisterData: [],
                    meterConfiguration: [],
                    MeterName: [''],
                    MeterType: [2],
                  })
                );
              } else {
                this.errorMsg =
                  'No. of Meter should be same as Maximum Analog Device Count !!';
              }
            }

            // if (EnergyMeterLength < DeviceControl.get("GSMConfigDataBO").value.MaximumSlave) {
            //   control.push(this.AddEnergyMeterArray());
            // }
            // else {
            //   this.errorMsg = 'No. of Meter should be same as Maximum Slave !!';
            // }
          } else {
            this.errorMsg =
              'Please configure Device ' +
              ++siteIndex +
              '.' +
              ++panelIndex +
              '.' +
              ++deviceIndex +
              ' first !!';

            return;
          }
        } else if (
          DeviceControl.get('MaximumSlave').value &&
          DeviceControl.get('MaximumSlave').value > 0 &&
          DeviceControl.get('DeviceProtocol').value &&
          DeviceControl.get('DeviceProtocol').value != '' &&
          this.addtiondevicetype == 1
        ) {
          if (filterdatadigital < DeviceControl.get('MaximumSlave').value) {
            control.push(
              this.form.group({
                EnergymeterID: [''],
                EnergymeterMasterID: [0],
                Mode: ['Add'], //Mayank
                EnergymeterDesc: [''],
                IsDisplay: [false],
                ValidToDate: [''],
                DeviceTypeId: [''],
                DeviceType: [''],
                RegisterData: [],
                meterConfiguration: [],
                MeterName: [''],
                MeterType: [1],
              })
            );
            // this.DigitalCount++
            filterdatadigital++;
          } else {
            this.errorMsg = 'No. of Meter should be same as Maximum Slave !!';
          }
        } else if (
          DeviceControl.get('MaxAnalogDevice').value &&
          DeviceControl.get('MaxAnalogDevice').value > 0 &&
          DeviceControl.get('DeviceProtocol').value &&
          DeviceControl.get('DeviceProtocol').value != '' &&
          this.addtiondevicetype == 2
        ) {
          if (filterdataanalog < DeviceControl.get('MaxAnalogDevice').value) {
            control.push(
              this.form.group({
                EnergymeterID: [''],
                EnergymeterMasterID: [0],
                Mode: ['Add'], //Mayank
                EnergymeterDesc: [''],
                IsDisplay: [false],
                ValidToDate: [''],
                DeviceTypeId: [''],
                DeviceType: [''],
                RegisterData: [],
                meterConfiguration: [],
                MeterName: [''],
                MeterType: [2],
              })
            );
            // this.AnalogCount++
            filterdataanalog++;
          } else {
            this.errorMsg =
              'No. of Meter should be same as Maximum Analog Device Count !!';
          }
        } else {
          this.errorMsg =
            'Please configure Device ' +
            ++siteIndex +
            '.' +
            ++panelIndex +
            '.' +
            ++deviceIndex +
            ' first !!';

          return;
        }
      }
    });
    this.errorMsg = '';

    this.CheckMeterLength();
  }

  //Called on Delete Site icon
  DeleteSite(index) {
    const control = <FormArray>this.AddSiteForm.controls['AddSiteArray'];

    var CompSiteId = control.at(index).value.CompSiteId;

    if (CompSiteId > 0) {
      const SiteValues = (this.AddSiteForm.get('AddSiteArray') as FormArray).at(
        index
      );
      SiteValues.get('Mode').patchValue('Delete');
    } else {
      control.removeAt(index);
    }
  }

  //Called on Delete Site icon
  DeletePanel(siteIndex, panelIndex) {
    const control = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
      .at(siteIndex)
      .get('ListPanelMasterBO') as FormArray;

    var PanelId = control.at(panelIndex).value.SitePanelId;
    if (PanelId > 0) {
      const PanelValues = (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(siteIndex)
          .get('ListPanelMasterBO') as FormArray
      ).at(panelIndex);
      PanelValues.get('Mode').patchValue('Delete');
      const SiteValues = (this.AddSiteForm.get('AddSiteArray') as FormArray).at(
        siteIndex
      );
      SiteValues.get('Mode').patchValue('Edit');
    } else {
      control.removeAt(panelIndex);
    }
  }
  //called on Delete Device// tathya
  DeleteDeviceType(siteIndex, panelIndex, deviceIndex) {
    const control = (
      (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
        .at(siteIndex)
        .get('ListPanelMasterBO') as FormArray
    )
      .at(panelIndex)
      .get('ListDevicetypeMasterBO') as FormArray;
    const DeviceTypeValues = (
      (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(siteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(panelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    ).at(deviceIndex);
    DeviceTypeValues.get('Mode').patchValue('Delete');
    const PanelValues = (
      (this.AddSiteForm.get('AddSiteArray') as FormArray)
        .at(siteIndex)
        .get('ListPanelMasterBO') as FormArray
    ).at(panelIndex);
    PanelValues.get('Mode').patchValue('Edit');
    const SiteValues = (this.AddSiteForm.get('AddSiteArray') as FormArray).at(
      siteIndex
    );
    SiteValues.get('Mode').patchValue('Edit');
  }
  //Called on Delete EM icon
  DeleteEnergyMeter(siteIndex, panelIndex, deviceIndex, energyIndex) {
    const control = (
      (
        (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
          .at(siteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(panelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    )
      .at(deviceIndex)
      .get('ListEnergymeterMasterBO') as FormArray;
    var EmeterId = control.at(energyIndex).value.EnergymeterMasterID;
    if (EmeterId > 0) {
      const EnergyMeterValues = (
        (
          (
            (this.AddSiteForm.get('AddSiteArray') as FormArray)
              .at(siteIndex)
              .get('ListPanelMasterBO') as FormArray
          )
            .at(panelIndex)
            .get('ListDevicetypeMasterBO') as FormArray
        )
          .at(deviceIndex)
          .get('ListEnergymeterMasterBO') as FormArray
      ).at(energyIndex);
      EnergyMeterValues.get('Mode').patchValue('Delete');
      const DeviceTypeValues = (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(siteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(panelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      ).at(deviceIndex);
      DeviceTypeValues.get('Mode').patchValue('Edit');
      const PanelValues = (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(siteIndex)
          .get('ListPanelMasterBO') as FormArray
      ).at(panelIndex);
      PanelValues.get('Mode').patchValue('Edit');
      const SiteValues = (this.AddSiteForm.get('AddSiteArray') as FormArray).at(
        siteIndex
      );
      SiteValues.get('Mode').patchValue('Edit');
    } else {
      control.removeAt(energyIndex);
    }
  }

  getInitialEM() {
    const SiteArray = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    SiteArray.value.forEach((element, i) => {
      // Mayank Dulera
      const SiteNameValues = (
        this.AddSiteForm.get('AddSiteArray') as FormArray
      ).at(i);
      var sname = SiteNameValues.get('CompSiteName').value;
      this.initialSN.push(sname);
      const PanelArray = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
        .at(i)
        .get('ListPanelMasterBO') as FormArray;
      PanelArray.value.forEach((element, j) => {
        // Mayank Dulera
        const PanelNameValues = (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        ).at(j);
        var pname = PanelNameValues.get('PanelName').value;
        this.initialPN.push(pname);

        const DeviceArray = (
          (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(j)
          .get('ListDevicetypeMasterBO') as FormArray;
        DeviceArray.value.forEach((element, k) => {
          const DeviceTypeValues = (
            (
              (this.AddSiteForm.get('AddSiteArray') as FormArray)
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          ).at(k);
          var DeviceId = DeviceTypeValues.get('DeviceName').value;
          this.initialDN.push(DeviceId);

          const EnergyMeterArray = (
            (
              (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          )
            .at(k)
            .get('ListEnergymeterMasterBO') as FormArray;
          EnergyMeterArray.value.forEach((element, l) => {
            const EnergyMeterValues = (
              (
                (
                  (this.AddSiteForm.get('AddSiteArray') as FormArray)
                    .at(i)
                    .get('ListPanelMasterBO') as FormArray
                )
                  .at(j)
                  .get('ListDevicetypeMasterBO') as FormArray
              )
                .at(k)
                .get('ListEnergymeterMasterBO') as FormArray
            ).at(l);
            var EMId = EnergyMeterValues.get('EnergymeterID').value;
            this.initialEM.push(EMId);
          });
        });
      });
    });
  }

  //Called on Save button click // Mayank Dulera
  SaveSite() {
    this.ErrorMassage = '';

    const SiteArray = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    SiteArray.value.forEach((element, i) => {
      const SiteNameValues = (
        this.AddSiteForm.get('AddSiteArray') as FormArray
      ).at(i);
      var sname = SiteNameValues.get('CompSiteName').value;

      //Sweta Jain : Remove from SiteArray when SiteName is null or blank

      if (sname == '' || sname == null) {
        // SiteArray.removeAt(i);
        this.errorMsg = `Enter Site Name for (${i + 1})`;
        throw 'break';
      }

      const PanelArray = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
        .at(i)
        .get('ListPanelMasterBO') as FormArray;
      PanelArray.value.forEach((element, j) => {
        const PanelValues = (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        ).at(j);
        var pname = PanelValues.get('PanelName').value;

        if (pname == '' || pname == null) {
          this.errorMsg = `Enter Location Name for (${i + 1}.${j + 1})`;
          throw 'break';
        }

        const DeviceArray = (
          (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(j)
          .get('ListDevicetypeMasterBO') as FormArray;

        DeviceArray.value.forEach((element, k) => {
          const DeviceTypeValues = (
            (
              (this.AddSiteForm.get('AddSiteArray') as FormArray)
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          ).at(k);

          let datevalue = DeviceTypeValues.get('InstallationDate').value;
          datevalue = this.datePipe.transform(datevalue, 'yyyy-MM-dd');
          DeviceTypeValues.get('InstallationDate').patchValue(datevalue);

          var dname = DeviceTypeValues.get('DeviceName').value;

          if (dname == '' || dname == null) {
            this.errorMsg = `Enter Device Name for (${i + 1}.${j + 1}.${
              k + 1
            })`;
            throw 'break';
          }
          let meterNamesBySite: any = {};
          const EnergyMeterArray = (
            (
              (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          )
            .at(k)
            .get('ListEnergymeterMasterBO') as FormArray;
          EnergyMeterArray.value.forEach((element, l) => {
            const EnergyMeterValues = (
              (
                (
                  (this.AddSiteForm.get('AddSiteArray') as FormArray)
                    .at(i)
                    .get('ListPanelMasterBO') as FormArray
                )
                  .at(j)
                  .get('ListDevicetypeMasterBO') as FormArray
              )
                .at(k)
                .get('ListEnergymeterMasterBO') as FormArray
            ).at(l);

            // if (EnergyMeterValues.get("MeterType").value) {
            //   let int = EnergyMeterValues.get("MeterType").value == "Digital" ? 1 : 2
            //   EnergyMeterValues.get("MeterType").patchValue(int)
            // }
            let datevalue = EnergyMeterValues.get('ValidToDate').value;
            datevalue = this.datePipe.transform(datevalue, 'yyyy-MM-dd');
            EnergyMeterValues.get('ValidToDate').patchValue(datevalue);
            var ename = EnergyMeterValues.get('EnergymeterID').value;
            var mname = EnergyMeterValues.get('MeterName').value;

            // Check for duplicate meter names within the same site
            if (
              meterNamesBySite[sname] &&
              meterNamesBySite[sname].includes(mname)
            ) {
              this.errorMsg = `Duplicate meter name : ${mname} found for site : ${sname}`;
              throw 'break';
            }
            meterNamesBySite[sname] = meterNamesBySite[sname] || [];
            meterNamesBySite[sname].push(mname);

            if (ename == '' || ename == null) {
              this.errorMsg = `Enter Meter ID for (${i + 1}.${j + 1}.${k + 1}.${
                l + 1
              })`;
              throw 'break';
            }

            if (mname == '' || mname == null) {
              this.errorMsg = `Enter Meter Name for (${i + 1}.${j + 1}.${
                k + 1
              }.${l + 1})`;
              throw 'break';
            }

            if (SiteNameValues.value.CompSiteId != null) {
              if (
                SiteNameValues.value.Mode === 'Delete' ||
                PanelValues.value.Mode === 'Delete'
              ) {
                PanelValues.value.Mode = 'Delete';
                EnergyMeterValues.value.Mode = 'Delete';
              }
            }
            if (PanelValues.value.PanelId != null) {
              if (PanelValues.value.Mode === 'Delete') {
                DeviceTypeValues.value.Mode = 'Delete';
              }
            }
            if (DeviceTypeValues.value.DeviceId != null) {
              if (DeviceTypeValues.value.Mode === 'Delete') {
                EnergyMeterValues.value.Mode = 'Delete';
              }
            }
          });
        });
      });
    });

    let ReqObj = {
      CompanyId: this.CompanyId,
      // Mode: 'Edit',
      ListCompSiteMasterBO: SiteArray.value,
      RoleName: this.RoleName,
    };

    this.companyservice.AddCompany(ReqObj).subscribe(
      (result) => {
        if (result) {
          window.location.reload();
          localStorage.setItem('IsFromAddCompany', 'Y');
        }
      },
      (error) => {
        if (error == undefined) {
          this.errorMsg = 'Something went wrong!!';
        } else {
          this.errorMsg = error;
        }
      }
    );
  }

  //called on cancel button
  OnCancel() {
    //this.dialogRef.close();
  }

  // Get Device Type List
  // GetDeviceTypeList() {
  //   this.commonservice.GetDeviceTypeList().subscribe(
  //     (result) => {
  //       this.DeviceTypeList = result;
  //     },
  //     (error) => {
  //       this.errorMsg = error
  //     }
  //   )
  // }

  // On Change Device Type
  // OnChangeDeviceType(event, SiteIndex, PanelIndex, DeviceIndex, EnergyIndex) {
  //   this.errorMsg = '';
  //   const EMValues = ((((this.AddSiteForm.get('AddSiteArray') as FormArray).at(SiteIndex).get('ListPanelMasterBO') as FormArray).at(PanelIndex).get("ListDevicetypeMasterBO") as FormArray).at(DeviceIndex).get("ListEnergymeterMasterBO") as FormArray).at(EnergyIndex);
  //   if (event.value > 0) {
  //     EMValues.get("DeviceTypeId").patchValue(event.value);
  //     EMValues.get("DeviceType").patchValue(event.source.triggerValue);
  //   }
  // }

  OnConfigRegister(SiteIndex, PanelIndex, DeviceIndex, EnergyIndex) {
    const EnergyMetervalue = (
      (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('ListEnergymeterMasterBO') as FormArray
    ).at(EnergyIndex);
    try {
      this.EnergyMeterID = EnergyMetervalue.value.EnergymeterMasterID;
    } catch (e) {
      this.EnergyMeterID = 0;
    }
    var selectedmetername = EnergyMetervalue.get('MeterName').value;

    this.errorMsg = '';
    var DeviceControl = (
      (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(SiteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(PanelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    ).at(DeviceIndex);

    if (DeviceControl.get('GSMConfigDataBO').value) {
      if (DeviceControl.get('GSMConfigDataBO').value.KeyID) {
        DeviceControl.get('KeyID').patchValue(
          DeviceControl.get('GSMConfigDataBO').value.KeyID
        );
      }
    }

    if (DeviceControl.get('GSMConfigDataBO').value) {
      if (DeviceControl.get('GSMConfigDataBO').value.dtype) {
        DeviceControl.get('dtype').patchValue(
          DeviceControl.get('GSMConfigDataBO').value.dtype
        );
      }
    }

    if (DeviceControl.get('MQTTSettingDataBO').value) {
      if (DeviceControl.get('MQTTSettingDataBO').value.DeviceProtocol) {
        if (DeviceControl.get('MQTTSettingDataBO').value.DeviceProtocol == 0) {
          DeviceControl.get('DeviceProtocol').patchValue('HTTP');
        } else if (
          DeviceControl.get('MQTTSettingDataBO').value.DeviceProtocol == 1
        ) {
          DeviceControl.get('DeviceProtocol').patchValue('FTP');
        }
      }
    }

    // For Get DeviceProtocol Value

    var DeviceProtocol = DeviceControl.get('DeviceProtocol').value;
    if (this.DPName) DeviceProtocol = this.DPName;

    var KeyID = DeviceControl.get('KeyID').value;

    const EnergyMetervalues = (
      (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('ListEnergymeterMasterBO') as FormArray
    ).at(EnergyIndex);

    const EnergyDevicevalues = (
      (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(SiteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(PanelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    ).at(DeviceIndex);
    this.devicecounterlist = [];
    if (EnergyDevicevalues.value.DeviceId != 0) {
      for (
        let index = 1;
        index <= EnergyDevicevalues.value.MaxAnalogDevice;
        index++
      ) {
        this.devicecounterlist.push(index);
      }
    } else {
      let value = this.maindict[SiteIndex];
      let analogcount = value[0]?.maxanalog;

      for (let index = 1; index <= analogcount; index++) {
        this.devicecounterlist.push(index);
      }
    }

    // let analoganddigitaltype = EnergyMetervalues.value.MeterType == 'Digital' ? 1 : 2
    let analoganddigitaltype = EnergyMetervalues.value.MeterType;
    try {
      this.EnergyMeterID = EnergyMetervalues.value.EnergymeterMasterID;
    } catch (e) {
      this.EnergyMeterID = 0;
    }

    if (this.EnergyMeterID == null) {
      this.EnergyMeterID = 0;
    }
    if (DeviceProtocol && KeyID) {
      if (analoganddigitaltype == 1) {
        const Setparamdialogref = this.dialog.open(RegisterpanelComponent, {
          width: '3100px',
          height: '530px',
          data: {
            EnergyMeterdata: {
              EMID: this.EnergyMeterID,
              RegisterData: EnergyMetervalues.get('RegisterData').value,
              meterConfiguration: EnergyMetervalues.get('meterConfiguration')
                ? EnergyMetervalues.get('meterConfiguration').value
                : '',
              DeviceProtocol: DeviceProtocol,
              EMIndex: EnergyIndex,
              KeyID: KeyID,
              selectedmetername: selectedmetername,
              metertype: 1,
            },
          },
        });
        Setparamdialogref.afterClosed().subscribe((result) => {
          if (result != undefined) {
            const EnergyMetervalues = (
              (
                (
                  (this.AddSiteForm.get('AddSiteArray') as FormArray)
                    .at(SiteIndex)
                    .get('ListPanelMasterBO') as FormArray
                )
                  .at(PanelIndex)
                  .get('ListDevicetypeMasterBO') as FormArray
              )
                .at(DeviceIndex)
                .get('ListEnergymeterMasterBO') as FormArray
            ).at(EnergyIndex);
            EnergyMetervalues.get('RegisterData').patchValue(
              result.RegisterData
            );
            if (result.meterConfiguration.CalibrationCertificate) {
              EnergyMetervalues.get('meterConfiguration').patchValue(
                result.meterConfiguration
              );
            }
          }
        });
      } else if (analoganddigitaltype == 2) {
        const Setparamdialogref = this.dialog.open(
          AnalogRegisterpanelComponent,
          {
            width: '3100px',
            height: '530px',
            data: {
              EnergyMeterdata: {
                EMID: this.EnergyMeterID,
                RegisterData: EnergyMetervalues.get('RegisterData').value,
                meterConfiguration: EnergyMetervalues.get('meterConfiguration')
                  ? EnergyMetervalues.get('meterConfiguration').value
                  : '',
                DeviceProtocol: DeviceProtocol,
                EMIndex: EnergyIndex,
                KeyID: KeyID,
                selectedmetername: selectedmetername,
                devicecounterlist: this.devicecounterlist,
                metertype: 2,
              },
            },
          }
        );
        Setparamdialogref.afterClosed().subscribe((result) => {
          if (result != undefined) {
            const EnergyMetervalues = (
              (
                (
                  (this.AddSiteForm.get('AddSiteArray') as FormArray)
                    .at(SiteIndex)
                    .get('ListPanelMasterBO') as FormArray
                )
                  .at(PanelIndex)
                  .get('ListDevicetypeMasterBO') as FormArray
              )
                .at(DeviceIndex)
                .get('ListEnergymeterMasterBO') as FormArray
            ).at(EnergyIndex);
            EnergyMetervalues.get('RegisterData').patchValue(
              result.RegisterData
            );
            if (result.meterConfiguration.CalibrationCertificate) {
              EnergyMetervalues.get('meterConfiguration').patchValue(
                result.meterConfiguration
              );
            }
          }
        });
      } else if (analoganddigitaltype == 3) {
        const Setparamdialogref = this.dialog.open(
          VirtualRegisterpanelComponent,
          {
            width: '2000px',
            height: '470px',
            data: {
              EnergyMeterdata: {
                EMID: this.EnergyMeterID,
                RegisterData: EnergyMetervalues.get('RegisterData').value,
                DeviceProtocol: DeviceProtocol,
                EMIndex: EnergyIndex,
                KeyID: KeyID,
                selectedmetername: selectedmetername,
                devicecounterlist: this.devicecounterlist,
                metertype: 3,
              },
            },
          }
        );
        Setparamdialogref.afterClosed().subscribe((result) => {
          if (result != undefined) {
            const EnergyMetervalues = (
              (
                (
                  (this.AddSiteForm.get('AddSiteArray') as FormArray)
                    .at(SiteIndex)
                    .get('ListPanelMasterBO') as FormArray
                )
                  .at(PanelIndex)
                  .get('ListDevicetypeMasterBO') as FormArray
              )
                .at(DeviceIndex)
                .get('ListEnergymeterMasterBO') as FormArray
            ).at(EnergyIndex);
            EnergyMetervalues.get('RegisterData').patchValue(result);
          }
        });
      }
    } else {
      this.errorMsg =
        'Please select Device Type first from Device Settings Tab.';
      return;
    }
  }

  //open configpopup
  OnConfig(SiteIndex, PanelIndex, DeviceIndex) {
    this.errorMsg = '';
    const DeviceValue = (
      (
        (this.AddSiteForm.get('AddSiteArray') as FormArray)
          .at(SiteIndex)
          .get('ListPanelMasterBO') as FormArray
      )
        .at(PanelIndex)
        .get('ListDevicetypeMasterBO') as FormArray
    ).at(DeviceIndex);

    try {
      this.DeviceGSMConfigID = (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('GSMDeviceConfigID').value; //GSMDeviceConfigID
    } catch (e) {
      this.DeviceGSMConfigID = 0;
    }
    try {
      this.DeviceRTCConfigID = (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('GSMDeviceConfigID').value; //RTCDeviceConfigID
    } catch (e) {
      this.DeviceRTCConfigID = 0;
    }
    try {
      this.DeviceMQTConfigID = (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('GSMDeviceConfigID').value; //GSMDeviceConfigID
    } catch (e) {
      this.DeviceMQTConfigID = 0;
    }
    try {
      this.DeviceTypeId = (
        (
          (this.AddSiteForm.get('AddSiteArray') as FormArray)
            .at(SiteIndex)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(PanelIndex)
          .get('ListDevicetypeMasterBO') as FormArray
      )
        .at(DeviceIndex)
        .get('DeviceTypeID').value;
    } catch (e) {
      this.DeviceTypeId = 0;
    }

    if (this.DeviceGSMConfigID == null) {
      this.DeviceGSMConfigID = 0;
    }
    if (this.EnergyMeterID == null) {
      this.EnergyMeterID = 0;
    }

    if (DeviceValue.value.DeviceName) {
      const Setparamdialogref = this.dialog.open(GSMConfigComponent, {
        width: '730px',
        height: '515px',
        data: {
          GSMConfigAllData: {
            DeviceTypeID: this.DeviceTypeId,
            DeviceName: DeviceValue.value.DeviceName,
            InstallationDate: DeviceValue.value.InstallationDate,
            DeviceGSMID: this.DeviceGSMConfigID,
            DeviceRTCID: this.DeviceRTCConfigID,
            DeviceMQTID: this.DeviceMQTConfigID,
            DeviceGSMData: DeviceValue.get('GSMConfigDataBO').value,
            DeviceRTCData: DeviceValue.get('RTCSettingDataBO').value,
            DeviceMQTData: DeviceValue.get('MQTTSettingDataBO').value,
            DeviceEthernetTcpSettingsData: DeviceValue.get(
              'EthernetTcpSettingsBO'
            ).value,
          },
        },
      });

      // //Callback method of popup close
      Setparamdialogref.afterClosed().subscribe((result) => {
        if (result) {
          const DeviceValues = (
            (
              (this.AddSiteForm.get('AddSiteArray') as FormArray)
                .at(SiteIndex)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(PanelIndex)
              .get('ListDevicetypeMasterBO') as FormArray
          ).at(DeviceIndex);
          // if (result.GSMConfigFormSaveData) {
          this.newmaindevicedata = result.GSMConfigFormSaveData;
          if (this.newmaindevicedata.DeviceTypeID == 0) {
            let MaxAnalogDevice = this.newmaindevicedata.MaxAnalogDevice;
            if (!this.maindict[SiteIndex]) {
              this.maindict[SiteIndex] = [{ maxanalog: MaxAnalogDevice }];
            } else {
              this.maindict[SiteIndex].push({ maxanalog: MaxAnalogDevice });
            }
          }

          DeviceValues.get('GSMConfigDataBO').patchValue(
            result.GSMConfigFormSaveData
          );
          // }
          // else if (result.RTCData) {
          DeviceValues.get('RTCSettingDataBO').patchValue(result.RTCData);
          // }
          // else if (result.SettingsData) {
          DeviceValues.get('MQTTSettingDataBO').patchValue(result.SettingsData);
          DeviceValues.get('EthernetTcpSettingsBO').patchValue(
            result.EthernetTcpSettingsBO
          );
          // }
          // else {
          if (result.DeviceProtocolName != null) {
            this.DPName = result;
          }
          // }
        }
      });
    } else {
      this.errorMsg = 'Please enter Device Name first!!';
      return;
    }
  }

  // Check Site, Panel, Meter Name Exist
  CheckNameExist(Type, value) {
    if (value != '') {
      this.assignmeterservice.CheckEnergyMeterExist(Type, value).subscribe(
        (result) => {
          this.message = result.Response;
          if (Type == 'Site') {
            if (this.message == 'Site already exist') {
              this.errorMsg = 'Site already exist!!';
            } else if (Type == 'Panel') {
              this.errorMsg = 'Location already exist!!';
            } else if (Type == 'EnergyMeter') {
              this.errorMsg = 'Meter already exist!!';
            }
          } else {
            this.errorMsg = '';
          }
        },
        (error) => {
          this.errorMsg = `service failure ${error}`;
        }
      );
    }
  }

  CheckMeterLength() {
    this.EMtoalLength = 0;
    const SiteArray = <FormArray>this.AddSiteForm.controls['AddSiteArray'];
    SiteArray.value.forEach((element, i) => {
      const PanelArray = (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
        .at(i)
        .get('ListPanelMasterBO') as FormArray;
      PanelArray.value.forEach((element, j) => {
        const DeviceArray = (
          (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
            .at(i)
            .get('ListPanelMasterBO') as FormArray
        )
          .at(j)
          .get('ListDevicetypeMasterBO') as FormArray;
        DeviceArray.value.forEach((element, k) => {
          const EnergyMeterArray = (
            (
              (<FormArray>this.AddSiteForm.controls['AddSiteArray'])
                .at(i)
                .get('ListPanelMasterBO') as FormArray
            )
              .at(j)
              .get('ListDevicetypeMasterBO') as FormArray
          )
            .at(k)
            .get('ListEnergymeterMasterBO') as FormArray;
          this.EMtoalLength = this.EMtoalLength + EnergyMeterArray.length;
        });
      });
    });
  }
}
